import * as turf from '@turf/turf';
import { LngLatBoundsLike, MapRef } from 'react-map-gl';
import { TsGpsPoint } from 'seacube-backend/src/api/client';

interface Props {
  gpsData: any;
  mapRef: React.RefObject<MapRef>;
}

export const getBbox = (gpsPoints: TsGpsPoint[]) => {
  const points = gpsPoints.map((point) => [point.lon, point.lat]);
  points.push(points[0]);

  // Il faut un minium de 4 points pour créer un bbox (rectangle), si on a moins de 4 points, on duplique le premier point
  if (points.length < 4) {
    const missingPoints = 4 - points.length;
    for (let i = 0; i < missingPoints; i++) {
      points.push(points[0]);
    }
  }

  const polygon = turf.polygon([points]);
  const bbox = turf.bbox(polygon);
  return bbox as LngLatBoundsLike;
};

export const zoomToTimeSpan = ({ mapRef, gpsData }: Props) => {
  if (gpsData.length === 0) return;
  const bbox = getBbox(gpsData);

  if (mapRef.current && bbox) {
    mapRef.current.fitBounds(bbox, {
      padding: 100,
      speed: 5,
      maxZoom: 15,
    });
  }
};
